import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track5BBlue = ({ state, workState, onLabelClick }) => (
	<>
		<g id="Track5BBlue-line" transform="translate(1961.000000, 429.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}>
			<path
				d="M-3.05533376e-13,80.6687288 L85.9946104,50.1023054 C92.7596652,47.6976951 96.2945039,40.2642128 93.8898935,33.499158 C92.5166181,29.6356283 89.4010688,26.6464365 85.4840236,25.4342055 L4.01318191,0.220944431 L4.01318191,0.220944431"
				id="line"/>
		</g>
		<g id="Track5BBlue" transform="translate(1827.000000, 387.000000)" className="track">
			<g id="line" transform="translate(0.206395, 0.741820)"
				 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
				 strokeWidth={tracksWidth}
			>
				<path
					d="M94.4905215,147.459827 L69.6261556,169.266946 C60.9706983,176.858154 55.0791664,187.107135 52.875282,198.406971 L46.0141282,233.585725 L46.0141282,233.585725"
					transform="translate(70.252325, 190.522776) rotate(3.000000) translate(-70.252325, -190.522776) "/>

				<TrackArrow
					transform="translate(107.976138, 140.944630) rotate(-40.000000) translate(-107.976138, -140.944630) "
					points="111.976138 148.94463 103.976138 140.94463 111.976138 132.94463"/>

				<path
					d="M4.09569913,4.53122637 L67.0712126,20.7732283 M80.1940973,24.1577488 L114.305969,32.9555346 C115.179089,33.1807208 116.049123,33.417706 116.915833,33.6664251 L162.43995,46.7304478 C175.958687,50.6099097 183.772863,64.7139361 179.893401,78.2326726 C178.460121,83.2272131 175.533287,87.6637854 171.505757,90.9468827 L109.734226,141.30081 L109.734226,141.30081"
					transform="translate(92.491813, 72.916018) rotate(3.000000) translate(-92.491813, -72.916018) "/>

				<TrackArrow transform="translate(68.010761, 18.817726) rotate(-161.000000) translate(-68.010761, -18.817726) "
										points="72.0107609 26.817726 64.0107609 18.817726 72.0107609 10.817726"/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track5BBlue')}
				coords="120.159076, 103.120229"
				text="5B"
				textCoordsX="10.3686523"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track5BBlue')}
				coords="87.159076, 18.120229"
				text="5B"
				textCoordsX="10.3686523"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>
		</g>


	</>
);

Track5BBlue.propTypes = trackPropTypes;

export default Track5BBlue;
